export default "__VITE_ASSET__C3737GQW__"